<template>
  <div class="col-md-6 subscription-card">
    <div>
      <div class="subscription-card-title">
        <div>
          <span class="text-muted">{{ title[0] }}</span>
        </div>
        <div>
          <span>{{ title[1] }}</span>
          <span>FCFA</span>
        </div>
      </div>
      <div class="text-muted text-truncate">
        {{ bundle.description }}
      </div>
      <div class="description">
        {{ bundle.status }}
      </div>
      <!-- <div
        v-if="bundle.id.toLowerCase().search(/gopack/i) != -1"
        class="subscription-card-details mt-2"
      >
        <div>
          <span>Appel</span>
          <span>{{ parse_GoPack(bundle.status, "remaining_min") }} min</span>
        </div>
        <div>
          <span>SMS</span>
          <span>{{ parse_GoPack(bundle.status, "remaining_sms") }}</span>
        </div>
        <div>
          <span>Internet</span>
          <span>{{
            parse_GoPack(bundle.status, "remaining_net") +
            " " +
            parse_GoPack(bundle.status, "remaining_net_unit")
          }}</span>
        </div>
      </div> -->
      <!-- <div v-if="bundle.id.toLowerCase().search(/internet/i) != -1" class="">
        <div
          v-if="!parse_Internet(bundle.status, 'remaining_net')"
          class="m-0 momo-color font-14"
        >
          {{ bundle.status }}
        </div>

        <div
          v-if="parse_Internet(bundle.status, 'remaining_net')"
          class="m-0 momo-color font-14"
        >
          <div class="internet-bundle-container">
            <div>
              <span class="font-12 text-muted"
                >{{
                  parseInt(parse_Internet(bundle.status, "price")) -
                  parseInt(parse_Internet(bundle.status, "remaining_net"))
                }}Mo (consommé)</span
              >
            </div>
            <div class="bundle-internet-bar">
              <div :style="{ width: get_internet_remain_data() + '%' }"></div>
            </div>
            <div class="text-right font-12 mt-1 font-weight-bold">
              {{ parse_Internet(bundle.status, "remaining_net") }}Mo
            </div>
          </div>
        </div>
      </div> -->

      <div>
        <b-form-checkbox v-model="checked" switch size="md"></b-form-checkbox>
      </div>
      <button
        @click.prevent="renew()"
        v-b-tooltip.hover
        title="Reconduire"
        class="btn btn-outline-secondary renew-bundle-btn"
      >
        <i class="mdi mdi-reload"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { subscriber } from "@/services/";
export default {
  props: ["bundle"],
  components: {},
  name: "SubscriptionCard",
  data: function () {
    return {
      checked: true,
      title: this.get_bundle_title(),
    };
  },
  watch: {
    checked: function (new_val) {
      if (!new_val) {
        var self = this;
        setTimeout(function () {
          self.deactive_bundle();
        }, 200);
      }
    },
  },
  mounted: async function () {},
  methods: {
    deactive_bundle: async function () {
      if (!confirm(this.utils_get_config_message("bundle_deactive_message"))) {
        this.checked = true;
        return;
      }

      var response = await subscriber.deactive_bundle(this.bundle.id);
      if (_.isUndefined(response.error)) {
        var index = _.findLastIndex(this.$store.state.core.subscriptions, {
          id: this.bundle.id,
        });
        this.$delete(this.$store.state.core.subscriptions, index);
        this.utils_show_global_poup(response.response);
      }
    },
    renew: async function () {
      if (!confirm(this.utils_get_config_message("bundle_renew_message"))) {
        return;
      }

      var response = await subscriber.active_bundle(this.bundle.id);
      if (_.isUndefined(response.error)) {
        this.utils_show_global_poup(response.response);
      }
    },
    get_bundle_title: function () {
      var bdl = this.bundle.id.replace(/_+/, " ");
      bdl = bdl.split(" ");
      return bdl;
    },
    parse_GoPack: (mes, field) => {
      try {
        if (!mes) {
          return false;
        }
        let result = mes.match(
          /(?<forfait>[\s\w,:']* (?<price>\d+)(?<price_unit>[a-zA-Z]+)) [\s\w,:]* (?<remaining_min>\d+) (?<remaining_min_unit>[a-zA-Z]+) (?<remaining_sec>\d+) (?<remaining_sec_unit>[a-zA-Z]+) [\s\w,:']* (?<remaining_sms>\d+) (?<remaining_sms_unit>[a-zA-Z]+) [\s\w,:+']* (?<remaining_net>\d+.?\d*) (?<remaining_net_unit>[a-zA-Z]+) [\s\w,:']* (?<expiration_date>\d+-\d+-\d\d) [\s\w,:']* (?<expiration_time>\d+h\d+)./
        );
        if (!_.isUndefined(field)) {
          return result.groups[field];
        }
        return result.groups;
      } catch (error) {
        return "";
      }
    },
    parse_Internet: (mes, field) => {
      try {
        if (!mes) {
          return false;
        }
        mes = "forfait " + mes;
        let result = mes.match(
          /(?<forfait>[\s\w,:']* (?<price>\d+)(?<price_unit>[a-zA-Z]+)) [\s\w,.:]* (?<remaining_net>\d+.?\d*) (?<remaining_net_unit>[a-zA-Z]+) [\s\w,:']* (?<expiration_date>\d+-\d+-\d+) (?<expiration_time>\d+:\d+:\d+)./
        );
        if (!_.isUndefined(field)) {
          return result.groups[field];
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    get_internet_remain_data: function () {
      var remaining_net = parseInt(
        this.parse_Internet(this.bundle.status, "remaining_net")
      );
      var forfait = parseInt(this.parse_Internet(this.bundle.status, "price"));
      return 100 - (remaining_net * 100) / forfait;
    },
  },
};
</script>
<style scoped lang="css">
.bundle-internet-bar {
  position: relative;
  width: 100%;
  height: 15px;
  background: #ffcc26;
}

.bundle-internet-bar > div {
  position: absolute;
  height: 100%;
  background: #106887;
  color: #fff;
  text-align: right;
  line-height: 15px;
}

.bundle-internet-bar > div > div {
  padding-right: 10px;
}

.bundle-internet-bar > div > div span {
  font-size: 10px;
}

.internet-bundle-container {
  padding-right: 30px;
}
.description {
  font-size: 12px !important;
  font-weight: 400 !important;
  display: -webkit-box;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  -webkit-line-clamp: 4 !important;
}
</style>
